import React, { useEffect, useRef, useState } from 'react';
import './application.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import { isMobile } from 'react-device-detect';
import * as ReactDOM from 'react-dom';
import {
  getInputPropsWithSearch,
  getJsonFromStorage,
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { loadApplicationHistory } from '../actions';
import { getSystemData } from '../../System/reducer';
import { getApplicationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import { dateTimeFormatter, subjectFormatter, userPositionFormatter } from '../../../utils/formatters';
import ApplicationHistoryDialog from './ApplicationHistoryDialog';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { loadUserActionById } from '../../ReferenceInformation/actions';
import { getReferenceInformationData } from '../../ReferenceInformation/reducer';
import { APPLICATION_MODULE } from '../../../configs/moduleNames';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import getDefaultSort from '../../../utils/getDefaultSort';
import RowFilterForm from '../../FilterTemplate/components/RowFilterForm';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import MobileApplicationFooter from './MobileApplicationFooter';
import MobileApplicationHistoryFooter from './MobileApplicationHistoryFooter';
import PropertyGrid from '../../../components/base/Grid/PropertyGrid';

export default function ApplicationHistoryPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const subject_id = searchParams.get('subject_id');
  const { updatePeriod } = useSelector(getSystemData);
  const { applicationHistory = [], loadingApplicationHistory = false, applicationHistoryMeta } = useSelector(getApplicationData);
  const { currentUserActivity } = useSelector(getReferenceInformationData);
  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    // created_at_from: defaultDate[0], created_at_to: defaultDate[1],
    search: '', created_at: '',
  };
  const {
    getValues,
    control,
    setValue,
    watch,
    reset,
  } = useForm({ defaultValues: getJsonFromStorage('application-history-filter', defaultFilterValues) });

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[APPLICATION_MODULE].applicationHistoryMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
      sort,
    };
    if (subject_id) {
      requestData.filter.subject_id = subject_id;
    }
    const p1 = dispatch(loadApplicationHistory(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => loadData({ page: 1 }));
    return () => subscription.unsubscribe();
  }, [watch]);

  const handleSelectItem = i => {
    const p1 = dispatch(loadUserActionById(i.id)).then(data => {
      setSelectedItem(i);
    }).catch(responseLogWithNotification);
  };

  const columns = [
    {
      dataField: 'causer',
      text: 'Пользователь',
      headerClassName: 'user-column',
      formatter: userPositionFormatter,
    },
    {
      dataField: 'created_at',
      text: 'Дата и время',
      headerClassName: 'date-time-column',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'description',
      text: 'Версия',
      headerClassName: 'module-column',
    },
    {
      dataField: 'description',
      text: 'Тип изменения',
      headerClassName: 'module-column',
    },
    {
      dataField: 'context',
      text: 'Субъект',
      headerClassName: 'module-column',
      formatter: (_, item) => subjectFormatter(item),
    },
    {
      dataField: 'description',
      text: 'Изменения в объекте',
      headerClassName: 'changes-to-object-column',
    },
  ];

  const [sort, setSort] = useState(getDefaultSort(columns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const renderFooter = () => {
    const element = document.getElementById('app-content-footer');
    if (!element) {
      return null;
    }
    return ReactDOM.createPortal(<MobileApplicationHistoryFooter
      control={control}
      defaultFilterValues={defaultFilterValues}
      getValues={getValues}
      reset={reset}
      page={PAGE_TYPE.APPLICATION_HISTORY}
    />, element);
  };

  return (
    <div className="page application-page">
      <TimerLoader global loading={loadingApplicationHistory} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.application.history' })}</div>
        {!isMobile ? (
          <FilterRow>
            <RowFilterForm
              control={control}
              getValues={getValues}
              defaultValues={{}}
              page={PAGE_TYPE.APPLICATION_HISTORY}
            />
          </FilterRow>
        ) : null}
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          {!isMobile ? (
            <div className="grid-wrapper frame">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <CustomizedGrid
                  data={applicationHistory}
                  columns={columns}
                  name="application-history-list"
                  onDoubleClickByRow={handleSelectItem}
                  changeSort={changeSort}
                  sort={sort}
                  rowClassFormatter={item => (selectedItem && item.id === selectedItem.id ? 'clickable-table-row selected' : 'clickable-table-row')}
                />
              </div>
            </div>
          ) : (
            <PropertyGrid
              data={applicationHistory}
              columns={columns}
              name="application-history-list"
              onDoubleClickByRow={handleSelectItem}
              changeSort={changeSort}
              sort={sort}
              rowClassFormatter={item => (selectedItem && item.id === selectedItem.id ? 'clickable-table-row selected' : 'clickable-table-row')}
            />
          )}
          <Pagination meta={applicationHistoryMeta} list={applicationHistory} handleChangeMeta={loadData} />
        </div>
      </div>
      {selectedItem && currentUserActivity ? <ApplicationHistoryDialog close={() => setSelectedItem(null)} /> : null}
      {isMobile ? renderFooter() : null}
    </div>
  );
}
